import _ from 'lodash';

export const getTaskTypeCategoryName = option => option.categoryName;

export const getConditionSchemaStructureKey = (conditionTaskTypes = {}) =>
  _.values(conditionTaskTypes)
    .map(condition => {
      const tasks = _.values(condition.conditionTaskTypes ?? {})
        .map(task => `${task.taskTypeId}:${task.dataType}:${task.entityAssignmentType}`)
        .join(',');

      return `${condition.conditionId}[${tasks}]`;
    })
    .join('|');

export const getAvailableTaskTypeOptions = ({
  taskTypeOptions,
  conditionTaskTypes,
  validTaskTypeIds,
}) => {
  const presentTaskTypeIds = Object.keys(conditionTaskTypes ?? {});
  const isRestrictedToCondition = !_.isNil(validTaskTypeIds);

  return taskTypeOptions.filter(
    ({ taskTypeId }) =>
      !presentTaskTypeIds.includes(taskTypeId) &&
      (!isRestrictedToCondition || validTaskTypeIds.includes(taskTypeId)),
  );
};

export const addTaskToCondition = ({ form, conditionId, taskOption }) => {
  const updated = _.cloneDeep(form);
  const condition = updated.conditionTaskTypes[conditionId];

  condition.conditionTaskTypes = {
    ...condition.conditionTaskTypes,
    [taskOption.taskTypeId]: { conditionId, ...taskOption },
  };
  condition.removedTaskTypeIds = _.without(condition.removedTaskTypeIds, taskOption.taskTypeId);

  return updated.conditionTaskTypes;
};

export const removeTaskFromCondition = ({ form, conditionId, taskTypeId }) => {
  const updated = _.cloneDeep(form);
  const condition = updated.conditionTaskTypes[conditionId];

  condition.conditionTaskTypes = _.omit(condition.conditionTaskTypes, taskTypeId);
  condition.removedTaskTypeIds = _.union(condition.removedTaskTypeIds, [taskTypeId]);

  return updated.conditionTaskTypes;
};
